import { Turbo } from "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "../controllers"
import { removeOrphanOverlayBackdrops } from "../preline_init"
import { installTurboConfirmGuard } from "../confirm_guard"

import loading from "./loading"

window.Turbo = Turbo
installTurboConfirmGuard(Turbo)
ActiveStorage.start()

function reorderKanbanColumns() {
  const board = document.getElementById(this.target)
  if (!board) return

  let order = []
  try {
    order = JSON.parse((this.templateContent?.textContent || "").trim() || "[]")
  } catch (_) {
    return
  }
  if (!Array.isArray(order) || order.length === 0) return

  const byId = new Map()
  Array.from(board.children).forEach((el) => {
    if (el.id) byId.set(el.id, el)
  })
  order.forEach((id) => {
    const el = byId.get(id)
    if (el) board.appendChild(el)
  })

  const columns = Array.from(board.children)
  columns.forEach((column, index) => {
    column.querySelectorAll("form").forEach((form) => {
      const action = form.getAttribute("action") || ""
      if (!action.includes("/move")) return

      const button = form.querySelector("button")
      if (!button) return

      if (action.includes("direction=left")) {
        button.disabled = index === 0
      } else if (action.includes("direction=right")) {
        button.disabled = index === columns.length - 1
      }
    })
  })
}

Turbo.StreamActions.budget_kanban_reorder = reorderKanbanColumns
Turbo.StreamActions.sale_kanban_reorder = reorderKanbanColumns

let isNavigating = false
let pageSkeletonActive = false

const stopLoading = () => {
  isNavigating = false
  pageSkeletonActive = false
  loading.stop()
  window.clearTimeout(window.__mzLoadingWatchdog)
  document.body.classList.remove("overflow-hidden")
  removeOrphanOverlayBackdrops()
}

const isWhatsappUrl = (url) => {
  try {
    const path = new URL(url, window.location.origin).pathname
    return /\/application\/whatsapp(\/|$)/.test(path)
  } catch (_) {
    return false
  }
}

const isPriceTableShowUrl = (url) => {
  try {
    const path = new URL(url, window.location.origin).pathname
    return /\/application\/product_price_tables\/(?!new(?:\/|$))[^/]+\/?$/.test(path)
  } catch (_) {
    return false
  }
}

const showPageSkeleton = (url) => {
  const root = document.getElementById("page-content")
  if (!root) return false

  const toWhatsapp = isWhatsappUrl(url)
  const templateId = toWhatsapp
    ? "page-content-skeleton-whatsapp"
    : "page-content-skeleton"
  const template =
    document.getElementById(templateId) || document.getElementById("page-content-skeleton")
  if (!template?.content) return false

  const shell = document.querySelector(".app-page-shell")
  const bodyRow = document.querySelector(".app-body-row")

  // Ajusta o shell do main para o destino (rail do inbox/tabela vs página normal).
  if (toWhatsapp) {
    root.className =
      "flex min-w-0 flex-1 flex-col lg:ml-[4.25rem] min-h-0 overflow-hidden pb-0"
    document.body.classList.add("sidebar-rail")
    shell?.classList.add("min-h-0", "overflow-hidden")
    bodyRow?.classList.add("min-h-0", "overflow-hidden")
    shell?.querySelector(":scope > footer")?.classList.add("hidden")
  } else if (isPriceTableShowUrl(url)) {
    root.className = "flex min-w-0 flex-1 flex-col lg:ml-[4.25rem] pb-10"
    document.body.classList.add("sidebar-rail")
    shell?.classList.remove("min-h-0", "overflow-hidden")
    bodyRow?.classList.remove("min-h-0", "overflow-hidden")
  } else {
    root.className = "flex min-w-0 flex-1 flex-col lg:ml-64 pb-10"
    document.body.classList.remove("sidebar-rail")
    shell?.classList.remove("min-h-0", "overflow-hidden")
    bodyRow?.classList.remove("min-h-0", "overflow-hidden")
  }

  root.replaceChildren(template.content.cloneNode(true))
  root.setAttribute("aria-busy", "true")
  root.dataset.skeleton = "1"
  pageSkeletonActive = true

  try {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" })
  } catch (_) {
    window.scrollTo(0, 0)
  }

  return true
}

document.addEventListener("turbo:before-visit", (event) => {
  if (event.detail?.action === "restore") {
    stopLoading()
    return
  }

  const url = event.detail?.url
  if (!url) return

  // Filtros / query na mesma rota (ex.: busca de paciente em orçamentos):
  // não trocar #page-content pelo skeleton, senão o turbo-frame some e a tela fica em branco.
  try {
    const nextPath = new URL(url, window.location.origin).pathname
    if (nextPath === window.location.pathname) {
      isNavigating = false
      pageSkeletonActive = false
      return
    }
  } catch (_) {
    // segue com skeleton em URLs inválidas
  }

  isNavigating = true
  showPageSkeleton(url)
})

document.addEventListener("turbo:click", () => {
  isNavigating = true
})

const hideTurboProgress = () => {
  document.querySelectorAll(".turbo-progress-bar").forEach((el) => el.remove())
}

document.addEventListener("turbo:load", stopLoading)
document.addEventListener("turbo:load", hideTurboProgress)
document.addEventListener("turbo:before-render", stopLoading)
document.addEventListener("turbo:render", stopLoading)
document.addEventListener("turbo:frame-render", stopLoading)
document.addEventListener("turbo:frame-load", stopLoading)
document.addEventListener("turbo:fetch-request-error", stopLoading)
window.addEventListener("load", stopLoading)
window.addEventListener("load", hideTurboProgress)
document.addEventListener("turbo:visit", (event) => {
  if (event.detail?.action === "restore") stopLoading()
})

document.addEventListener("turbo:before-fetch-request", () => {
  // Navegação de página: skeleton no #page-content (sem overlay fullscreen).
  // Overlay permanece para submits/actions que chamam loading.start() direto.
  if (!isNavigating || pageSkeletonActive) return
  loading.start()
})

document.addEventListener("turbo:before-fetch-request", () => {
  if (!isNavigating) return
  window.clearTimeout(window.__mzLoadingWatchdog)
  window.__mzLoadingWatchdog = window.setTimeout(stopLoading, 15000)
})
